"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NextStepFirstAppointmentTookPlace = void 0;
const react_1 = __importDefault(require("react"));
const organisms_1 = require("../../../components/organisms");
const Breakpoints_1 = require("../../../helper/Breakpoints");
const NextStepFirstAppointmentTookPlace = () => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(organisms_1.TimelineEntry, { title: !Breakpoints_1.isMobileOrTablet
                ? 'Rezept einreichen'
                : 'Rezept' + '\n' + 'einreichen', infoText: "Zun\u00E4chst muss das Erstgespr\u00E4ch stattgefunden haben." }),
        react_1.default.createElement(organisms_1.TimelineEntry, { title: "Videosprechstunde vereinbaren", infoText: "Zun\u00E4chst muss das Rezept eingereicht worden sein." })));
};
exports.NextStepFirstAppointmentTookPlace = NextStepFirstAppointmentTookPlace;
